/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Patient Change Password View.
 */

// Redux Actions
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './patientChangePassword';

export const mapStateToPropsPatientChangePassword = mapStateToProps;
export const mapDispatchToPropsPatientChangePassword = mapDispatchToProps;

export default connect(
  mapStateToPropsPatientChangePassword,
  mapDispatchToPropsPatientChangePassword
)(View);
